import React, { useEffect } from 'react';
import {padaitem} from '../../json/PADAItem';
import './pada.css';

const Pada2 = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div className='container container-mh'>
            <div className='row'>
                <h3 className='title'>Programa Anual de Desarrollo Archivístico</h3>
                <hr className='hr-gob' />
            </div>
            <div className='row'>
                {
                    padaitem.map((item, index) => (
                        <div key={index} className='col-md-4 col-sm-6 col-12 pada_item'>
                            <a href={item.url} target="_blank">{item.anio}</a>
                            <hr class='row-separator'></hr>
                            <br></br>
                            <br></br>
                        </div>

                    ))
                }
            </div>
        </div>
    )
}

export default Pada2